import { jsx as r, jsxs as v } from "react/jsx-runtime";
import { useRadio as w, Box as a, chakra as y } from "@chakra-ui/react";
import B from "react";
import { hoverStylesCard as O } from "./hover-styles.js";
import { ThemeColorVariable as e, ThemeBorderVariable as c, ThemeSpaceVariable as t, ThemeRadiusVariable as F, ThemeFontSizeVariable as j, ThemeFontVariable as z } from "../../theme/theme-types.js";
const N = B.forwardRef(
  ({
    children: n,
    id: i,
    name: l,
    value: d,
    isChecked: s,
    defaultChecked: b,
    isDisabled: m,
    isFocusable: p,
    isReadOnly: h,
    isInvalid: u,
    isRequired: f,
    onChange: S,
    alignItems: _ = "center",
    alignContent: A = "center",
    ...o
  }, g) => {
    const { getInputProps: k, getRadioProps: x, htmlProps: C, getLabelProps: P } = w({
      id: i,
      name: l,
      value: d,
      isChecked: s,
      defaultChecked: b,
      isDisabled: m,
      isFocusable: p,
      isReadOnly: h,
      isInvalid: u,
      isRequired: f,
      onChange: S,
      ...o
    }), R = P(), T = k(), V = x();
    return /* @__PURE__ */ r(a, { as: "span", __css: O, w: "100%", children: /* @__PURE__ */ v(y.label, { ...R, ...C, cursor: "pointer", textAlign: "center", children: [
      /* @__PURE__ */ r("input", { ...T, ref: g }),
      /* @__PURE__ */ r(
        a,
        {
          ...V,
          ...o,
          className: "chakra-radio__control",
          whiteSpace: "nowrap",
          alignContent: A,
          alignItems: _,
          fontFamily: z.Body,
          fontSize: j.Medium,
          bg: e.Surface,
          border: c.XSmall,
          borderColor: e.OnSurfaceBorder,
          borderRadius: F.Small,
          px: t.Medium,
          py: t.Small,
          textColor: e.OnSurface,
          _checked: {
            textColor: e.OnAccent,
            bg: e.Accent,
            borderColor: e.Accent
          },
          _disabled: {
            opacity: 0.48,
            _checked: {
              bg: e.Accent,
              color: e.OnAccent
            }
          },
          _active: {
            background: e.AccentActiveAlpha,
            _checked: {
              background: e.AccentActive
            },
            _disabled: {
              background: e.Surface,
              _checked: {
                background: e.Accent
              }
            }
          },
          _invalid: {
            border: c.XSmall,
            borderColor: e.Error,
            boxShadow: `0 0 0 4px ${e.ErrorContainer}`
          },
          children: n
        }
      )
    ] }) });
  }
);
export {
  N as RadioCard
};
